const REGION_MAP = {
  US: 'us',
  default: 'international'
};

function getStoredRegion() {
  try { return localStorage.getItem('selected_region'); }
  catch(e) { return null; }
}

function setStoredRegion(region) {
  try {
    localStorage.setItem('selected_region', region);
    document.cookie = `selected_region=${region}; path=/; max-age=31536000`;
  } catch(e){}
}

function setRejectedRegion(region) {
  try {
    localStorage.setItem('region_rejected', region);
  } catch(e){}
}

async function detectCountry() {
  try {
    const res = await fetch('/browsing_context_suggestions.json');
    const data = await res.json();

    const iso = data?.detected_values?.country?.handle;
    if (iso) return iso.toUpperCase();

    return null;
  } catch (e) {
    return null;
  }
}

function getCurrentRegion() {
  const path = window.location.pathname;
  return path.startsWith('/en-international') ? 'international' : 'us';
}

function redirectToRegion(region, href = undefined) {
  const url = href
    ? new URL(href, window.location.origin)
    : new URL(window.location.href);

  const pathname = url.pathname;
  const search = url.search;
  const hash = url.hash;

  let targetPathname = pathname;

  if (region === 'us') {
    if (pathname.startsWith('/en-international')) {
      targetPathname = pathname.replace(/^\/en-international(?=\/|$)/, '') || '/';
    }
  } else {
    if (!pathname.startsWith('/en-international')) {
      targetPathname = '/en-international' + pathname;
    }
  }

  const target = `${targetPathname}${search}${hash}`;
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (target !== current) {
    window.location.replace(target);
  }
}

async function controlFooterRegions() {
  const footerRegionSelector = $('.region-choose-link');
  
}

const toggleRegionCardAnimation = (direction, selector_id) => {
  const selector = document.getElementById(selector_id);
  gsap.fromTo(selector, {
    opacity: direction ? 0 : 1,
  }, {
    opacity: direction ? 1 : 0,
    duration: 0.833,
    ease: 'pageInEasing',
    onStart: () => direction ? selector.style.display = 'flex' : false,
    onComplete: () => !direction ? selector.style.display = 'none' : false,
  })
}

async function initRegionSelector() {
  const manual = getStoredRegion();
  const current = getCurrentRegion();

  if (manual) {
    if (manual !== current) {
      redirectToRegion(manual);
    }
    return;
  }

  const countryCode = await detectCountry();
  const desired = REGION_MAP[countryCode] || REGION_MAP.default;

  if (current === desired || localStorage.getItem('region_rejected') === desired) {
    return;
  }

  $(window).on('heroReady', function () {
    toggleRegionCardAnimation(true, 'region-selector');

    document.getElementById('region-selector-accept').addEventListener('click', () => {
      setStoredRegion(desired);
      redirectToRegion(desired);
    });

    document.getElementById('region-selector-close').addEventListener('click', () => {
      setRejectedRegion(desired);
      toggleRegionCardAnimation(false, 'region-selector');
    });
  });
}

const initRegionChange = (region, href) => {
  const current = getCurrentRegion();
  toggleRegionCardAnimation(true, 'region-changer');

  $('.region-changer-accept').on('click', function () {
    setStoredRegion(region);
    toggleRegionCardAnimation(false, 'region-changer');

    if (window.location.href === href) {
      redirectToRegion(region);
    } else {
      redirectToRegion(region, href);
    }
  });

  $('.region-changer-close').on('click', function () {
    if (window.location.href === href) {
      redirectToRegion(current, '/');
    } else {
      toggleRegionCardAnimation(false, 'region-changer');
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initRegionSelector();
  document.querySelectorAll('.region-choose [data-region]').forEach(btn => {
    btn.addEventListener('click', () => {
      const region = btn.dataset.region;
      setStoredRegion(region);
      redirectToRegion(region);
    });
  });
});
